<div class="youtube-player-container" #youtubePlayerContainer>
  <div [id]="playerId"></div>
</div>
